import styled from 'styled-components';

import { Button } from '@components/button';
import { FormLabel } from '@components/form-label';
import { IconCopy } from '@components/icons/copy';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useClipboard } from '@hooks/use-clipboard';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';

export interface CopyTextProps {
  value: string;
  label?: string;
  helpText?: string;
  copiedText?: string;
  copyText?: string;
}

export function CopyText(props: CopyTextProps) {
  const { value, label, helpText, copiedText, copyText } = props;
  const { copied, onCopy } = useClipboard();
  const { t } = useScopedTranslate(locale);

  return (
    <Stack space={1}>
      {label && <FormLabel text={label} />}
      <CopyTextContainer>
        <TextToCopy>{value}</TextToCopy>
        <Button
          iconLeft={<IconCopy />}
          onClick={() => onCopy(value)}
          text={copied ? copiedText ?? t('copied') : copyText ?? t('copy')}
        />
      </CopyTextContainer>
      {helpText && <Text text={helpText} font="regular14" color="textHelper" />}
    </Stack>
  );
}

export const CopyTextContainer = styled.div({
  backgroundColor: theme.color.uiTrans5,
  borderRadius: '0.25rem',
  display: 'flex',
  gap: '0.75rem',
  paddingLeft: '0.75rem',
  height: theme.base.height,
  justifyContent: 'space-between',
  alignItems: 'center',
  button: {
    flexShrink: 0,
  },
});

export const TextToCopy = styled.span({
  color: theme.color.textPrimary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const locale = {
  en: {
    copy: 'Copy',
    copied: 'Copied',
  },
};
